export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-52581b4a396bfb517cd430c3507baa0f.svg";